var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "cart-totals-table" }, [
    _c("tr", [
      _c("th", [_vm._v("Subtotal")]),
      _c("td", [_vm._v(_vm._s(_vm._f("money")(_vm.totalPrice)))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }